import tw from "tailwind-styled-components";

const Card = ({ children }) => {
  return <CardContainer>{children}</CardContainer>;
};
const CardContainer = tw.div`bg-white rounded-2xl shadow-lg  md:absolute top-[23%]  lg:right-[6%] md:my-2 md:w-96  w-72 md:px-0 p-8 md:mb-0 md:mb-0 lg:mx-10 md:h-[400px] lg:h-auto`;
export default Card;
